<template src="./templates/date-picker.html"></template>
<script>

import {DatePicker} from 'v-calendar';
import FormButton from '@f/Button';

const default_values = {
    id: null,
    type: 'text',
    class: ''
};

export default {
    name: 'FormDatePicker',
    components: {
        DatePicker,
        FormButton
    },
    props: {
        preloader: {
            type: Boolean,
            default() {
                return false;
            }
        },
        modelValue: {
            type: String,
            default() {
                return null;
            },
        },
        attributes: {
            type: Object,
            default() {
                return default_values;
            }
        },
        label: {
            type: String,
            default() {
                return null;
            }
        },
        groupClass: {
            type: String,
            default() {
                return '';
            }
        },
        labelClass: {
            type: String,
            default() {
                return '';
            }
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            value: this.modelValue,
        };
    },
    computed: {
        labelClassPrep() {
            const cl = `${(this.labelClass) ? `${this.labelClass} ` : ''}`;
            return `${cl}h6`;
        },
        attributesPrep() {
            const attrs = {...default_values, ...this.attributes};
            
            if (!attrs.id) {
                attrs.id = `form-input-${Math.floor(Math.random() * 100000)}`;
            }
            
            return attrs;
        }
    },
    watch: {
        value: {
            handler(v, oldV) {
                this.$emit('update:modelValue', v);
            },
            deep: true,
        }
    }
};
</script>
